import React, { useState } from 'react';
import { useQuery, useLazyQuery, useMutation } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import EVENTS_TARGET from '../../../GraphQl/Queries/EVENTS_TARGET';
import { LoadingPage } from '../../../../platform/shared/LoadingPage';
import ErrorPage from '../../../../platform/shared/ErrorPage';
import GET_BASIC_TAG_ACTIVITY from '../../../GraphQl/Queries/GET_BASIC_TAG_ACTIVITY';
import CREATE_TEST_SIGNAL_LOGS from '../../../GraphQl/Mutations/CREATE_TEST_SIGNAL_LOGS';
import moment from 'moment';
import DELETE_EVENTS_TARGET from '../../../GraphQl/Mutations/DELETE_EVENTS_TARGET';
import DISABLE_ENDABLE_TAG from '../../../GraphQl/Mutations/DISABLE_ENABLE_TAG';
import REGENERATE_TAG from '../../../GraphQl/Mutations/REGENERATE_TAG';
import GET_CARTS from '../../../GraphQl/Queries/GET_CARTS';
import GET_DSP from '../../../GraphQl/Queries/GET_DSP';
import REGENERATE_IMPRESSION_TAG from '../../../GraphQl/Mutations/REGENERATE_IMPRESSION_TAG';
import { Alert } from 'antd';

const TagsDetailsLoader = (props) => {
  const { match, history, userPermission } = props;
  const id = match.params.id;
  const [basicTagActivityData, setBasicTagActivityData] = useState(null);
  const [persistedTagActivityData, setPersistedTagActivityData] = useState(null);

  const { data, loading, error, refetch } = useQuery(EVENTS_TARGET, {
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const {
    data: carts,
    loading: cartsLoading,
    error: cartsError,
  } = useQuery(GET_CARTS);
  const { data: dsps, loading: dspLoading } = useQuery(GET_DSP);

  const [regenerateTag] = useMutation(REGENERATE_TAG, {
    onCompleted: () => {
      console.log('Regenerate tag completed, refetching data...');
      refetch();
    },
  });
  const [regenerateImpressionsTag] = useMutation(REGENERATE_IMPRESSION_TAG, {
    onCompleted: () => {
      console.log('Regenerate impression tag completed, refetching data...');
      refetch();
    },
  });

  const [createLogs] = useMutation(CREATE_TEST_SIGNAL_LOGS, {
    onCompleted: () => refetch(),
  });
  const [getBasicTagActivity, { loading: tagActivityLoading }] = useLazyQuery(
    GET_BASIC_TAG_ACTIVITY,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        const { getBasicTagActivity } = data;
        setBasicTagActivityData(getBasicTagActivity);

        const retailIdData =
          getBasicTagActivity?.retailID?.map((item) => ({
            retailId: item.retailId || item.retailID,
            pageViews: item.pageViews || item.pageviews || 0,
            signups: item.signups || 0,
            transactions: item.transactions || 0,
            total: item.total || 0,
            sessions: item.sessions || 0,
          })) ?? [];

        // Store the persisted data with the correctly mapped retail IDs
        const persistedData = {
          ...getBasicTagActivity,
          retailID: retailIdData,
        };
        setPersistedTagActivityData(persistedData);

        createLogs({
          variables: {
            id,
            createLogs: {
              testDate: moment().format(),
              pageViews: getBasicTagActivity.pageViews,
              signups: getBasicTagActivity.signups,
              transactions: getBasicTagActivity.transactions,
              total: getBasicTagActivity.total,
              impressions: getBasicTagActivity.impressions,
              sessions: getBasicTagActivity.sessions,
              retailIds: {
                create: retailIdData,
              },
            },
          },
        });
      },
    }
  );
  const [deleteTag] = useMutation(DELETE_EVENTS_TARGET, {
    variables: {
      id,
    },
    onCompleted: () => {
      history.push('/tags/main');
    },
  });

  const [disableTag, { loading: disableEnableLoading }] = useMutation(DISABLE_ENDABLE_TAG, {
    onCompleted: () => refetch(),
  });

  if (loading || cartsLoading || dspLoading) return <LoadingPage />;
  if (error) return <ErrorPage />;

  const child = React.cloneElement(props.children, {
    ...props.children.props,
    data,
    getBasicTagActivity,
    basicTagActivityData,
    persistedTagActivityData,
    tagActivityLoading,
    deleteTag,
    disableTag,
    disableEnableLoading,
    regenerateTag,
    userPermission,
    carts,
    dsps,
    regenerateImpressionsTag,
  });

  if (!cartsError) return child;

  return (
    <>
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="Couldn't load cart providers"
        description="This is a temporary issue on our end — nothing was lost. Please refresh the page to try again; if it keeps happening, wait a moment or contact support."
      />
      {child}
    </>
  );
};

export default withRouter(TagsDetailsLoader);
